import { render } from "./WizardButtons.vue?vue&type=template&id=20af1250&bindings={\"prevButtonText\":\"props\",\"prevButtonDisabled\":\"props\",\"prevButtonVisible\":\"props\",\"prevButtonIsLoading\":\"props\",\"nextButtonText\":\"props\",\"nextButtonDisabled\":\"props\",\"nextButtonVisible\":\"props\",\"nextButtonIsLoading\":\"props\",\"prevButtonClick\":\"options\",\"nextButtonClick\":\"options\"}"
import script from "./WizardButtons.vue?vue&type=script&lang=js"
export * from "./WizardButtons.vue?vue&type=script&lang=js"

import "./WizardButtons.vue?vue&type=style&index=0&lang=scss"
script.render = render

export default script